import React from 'react';
import { Link } from 'react-router-dom';
import whatsappIcon from '../assets/iconos/whatsapp.png';

const Whatsapp = () => {
  return (
    <>
    {/**
     * <a
      href="https://wa.link/9qu07v"
      className="btn-whatsapp"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chatea con nosotros por WhatsApp"
    >
      <img src="%PUBLIC_URL%/whatsapp.png" alt="WhatsApp" />
    </a>
     *
     */}
      <a href="https://wa.link/9qu07v" className="btn-whatsapp" target="_blank"
      rel="noopener noreferrer"
      aria-label="Chatea con nosotros por WhatsApp">
        <img src={whatsappIcon} alt="WhatsApp" />
      </a>
    </>
  );
};

export default Whatsapp; 